export type PaymentMethod =
  | 'saferpay'
  | 'outlet'
  | 'rechnung'
  | 'cash'
  | 'postcard'
  | 'ec-maestro'
  | 'visa'
  | 'mastercard'
  | 'twint'
  | 'v-pay'
  | 'online-shop'
  | 'umtausch'
  | 'stage-x-umtausch'
  | 'offeriert'
  | '7-melons-offeriert'

export enum PaymentMethods {
  SAFERPAY = 'saferpay',
  OUTLET = 'outlet',
  RECHNUNG = 'rechnung',
  CASH = 'cash',
  POSTCARD = 'postcard',
  EC_MAESTRO = 'ec-maestro',
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  TWINT = 'twint',
  V_PAY = 'v-pay',
  ONLINE_SHOP = 'online-shop',
  UMTAUSCH = 'umtausch',
  STAGE_X_UMTAUSCH = 'stage-x-umtausch',
  OFFERIERT = 'offeriert',
  SEVEN_MELONS_OFFERIERT = '7-melons-offeriert',
}
